'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = exports.TabbedShowLayout = exports.SimpleShowLayout = exports.Show = exports.Edit = exports.Create = undefined;

var _Create2 = require('./Create');

var _Create3 = _interopRequireDefault(_Create2);

var _Edit2 = require('./Edit');

var _Edit3 = _interopRequireDefault(_Edit2);

var _Show2 = require('./Show');

var _Show3 = _interopRequireDefault(_Show2);

var _SimpleShowLayout2 = require('./SimpleShowLayout');

var _SimpleShowLayout3 = _interopRequireDefault(_SimpleShowLayout2);

var _TabbedShowLayout2 = require('./TabbedShowLayout');

var _TabbedShowLayout3 = _interopRequireDefault(_TabbedShowLayout2);

var _Tab2 = require('./Tab');

var _Tab3 = _interopRequireDefault(_Tab2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Create = _Create3.default;
exports.Edit = _Edit3.default;
exports.Show = _Show3.default;
exports.SimpleShowLayout = _SimpleShowLayout3.default;
exports.TabbedShowLayout = _TabbedShowLayout3.default;
exports.Tab = _Tab3.default;


//////////////////
// WEBPACK FOOTER
// ./~/admin-on-rest/lib/mui/detail/index.js
// module id = 482
// module chunks = 0